import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 0;
`;
Wrapper.displayName = 'Wrapper';

export const Label = styled.div`
  flex: 0 0 85px;
  font-size: 11.5px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.text.workspaceItem};
`;
Label.displayName = 'Label';

export const Content = styled.div`
  flex: 1 1 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.text.workspaceItem};
  font-size: 11.5px;
  font-stretch: normal;
  font-style: normal;
  font-weight: normal;
  letter-spacing: normal;
  line-height: normal;
  margin-left: 4px;
  display: flex;
`;
Content.displayName = 'Content';

export const Tool = styled.div`
  margin-left: 2px;
`;
Tool.displayName = 'Tool';
